import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import table from '@/components/builders/configs/tables/couponsListTable';
import filters from '@/components/builders/configs/filters/couponsListFilters';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import couponModal from './submodules/couponsModal';

const couponsListRepository = RepositoryFactory.get('coupons');
const state = {
  repository: couponsListRepository,
  error: null,
};

export default stateExtender({
  namespaced: true,
  state: () => state,
  modules: {
    table: datatableModule({
      fetch: couponsListRepository.table,
      headers: table.headers.filter((header) => header.isShown),
      allHeaders: table.headers,
      options: {
        sortBy: ['id'],
        sortDesc: [true],
        itemsPerPage: 30,
      },
      search: filters,
    }),
    couponModal,
  },
  getters,
  mutations,
  actions,
});
